import { AlertCircle } from 'lucide-react'
import { CUSTOMER_CODE_LABEL } from '@/data/customerCode'
import { useInfrastructureWizard } from '@/stores/infrastructureWizard'
import { requiresCustomerCode } from '@/utils/naming'
import styles from './Infrastructure.module.css'
import { CascadingLocationSelect } from './CascadingLocationSelect'
import { ReadOnlyInfoCard } from './ReadOnlyInfoCard'

/** Environment, region and resource group, strictly in that order. */
export function LocationStep() {
  const product = useInfrastructureWizard((s) => s.product)
  const environment = useInfrastructureWizard((s) => s.environment)
  const region = useInfrastructureWizard((s) => s.region)
  const resourceGroup = useInfrastructureWizard((s) => s.resourceGroup)
  const customerNumber = useInfrastructureWizard((s) => s.customerNumber)
  const setEnvironment = useInfrastructureWizard((s) => s.setEnvironment)
  const setRegion = useInfrastructureWizard((s) => s.setRegion)
  const setResourceGroup = useInfrastructureWizard((s) => s.setResourceGroup)
  if (!product) return null

  return (
    <>
      <CascadingLocationSelect
        product={product}
        environment={environment}
        region={region}
        resourceGroup={resourceGroup}
        onEnvironmentChange={setEnvironment}
        onRegionChange={setRegion}
        onResourceGroupChange={setResourceGroup}
      />
      {region && region.issues.length > 0 && (
        <div role="alert" className={styles.alert} style={{ flexDirection: 'column' }}>
          <span>
            <AlertCircle size={13} aria-hidden="true" style={{ marginRight: 6, verticalAlign: '-2px' }} />
            <strong>{region.label}</strong> cannot be deployed to yet. Choose a ready region, or have the platform or network team resolve the following first:
          </span>
          <ul style={{ margin: '0 0 0 20px', padding: 0 }}>
            {region.issues.map((issue) => (
              <li key={issue.message}>{issue.message}</li>
            ))}
          </ul>
        </div>
      )}
      {requiresCustomerCode(product) && (
        <ReadOnlyInfoCard
          title={CUSTOMER_CODE_LABEL}
          items={[{ label: CUSTOMER_CODE_LABEL, value: customerNumber !== null ? String(customerNumber) : 'Not entered yet', mono: customerNumber !== null }]}
          note={`Taken from the ${CUSTOMER_CODE_LABEL} field in the Environment section above. It identifies the customer in the pipeline and its tags. Server names do not use it.`}
        />
      )}
    </>
  )
}
